var _a;
import { entities } from "sb-bff-integration";
export var SelectionSide;
(function (SelectionSide) {
    SelectionSide[SelectionSide["Home"] = 1] = "Home";
    SelectionSide[SelectionSide["Draw"] = 2] = "Draw";
    SelectionSide[SelectionSide["Away"] = 3] = "Away";
})(SelectionSide || (SelectionSide = {}));
export var selectionOutcomeTypeMapper = (_a = {},
    _a[entities.OutcomeType.Home] = SelectionSide.Home,
    _a[entities.OutcomeType.Away] = SelectionSide.Away,
    _a[entities.OutcomeType.Over] = SelectionSide.Home,
    _a[entities.OutcomeType.Under] = SelectionSide.Away,
    _a[entities.OutcomeType.Draw] = SelectionSide.Draw,
    _a[entities.OutcomeType.Tie] = SelectionSide.Draw,
    _a);
//# sourceMappingURL=selectionOutcomeTypeMapper.js.map